import styled, { css } from 'styled-components';
import { scale010, scale020, scale030, scale050, scale060, scale100, scale110, scale130, xdlColorHover, xdlColorHoverSecondary, xdlColorLink, xdlColorPricing, xdlColorProBusiness, xdlColorSkeletonPrimary, xdlColorText, spaceL, spaceS, } from '@xingternal/tokens';
import { mediaConfinedNavlessOnly, mediaWideNavless, } from '@xingternal/layout-tokens';
import { Link } from '@xingternal/link';
import { IconWithBadge } from '@xingternal/platform-layout-icon-with-badge';
// @TODO: Find the JS alternative
const mediaXL = '(min-width: 1113px)';
const membershipToXdlColor = {
    premium: xdlColorLink,
    proJobs: xdlColorPricing,
    proBusiness: xdlColorProBusiness,
};
const linkBase = css `
  align-items: center;
  border-radius: ${scale130};
  color: ${xdlColorText};
  display: flex;
  margin-bottom: ${spaceL};
  padding: ${spaceS} ${spaceL};
  position: relative;

  @media ${mediaConfinedNavlessOnly} {
    border-radius: ${scale020};
    flex-direction: column;
    margin-bottom: 0;
  }

  &:hover {
    background-color: ${xdlColorHover};
  }
  &:active {
    background-color: ${xdlColorHoverSecondary};
  }

  &:hover,
  &:focus {
    text-decoration: none;
  }
`;
const PlaceholderLi = styled.li `
  padding: ${spaceS} ${scale030};

  @media ${mediaXL} {
    padding: ${spaceS} ${spaceL};
  }
`;
const PlaceholderIcon = styled.span `
  background-color: ${xdlColorSkeletonPrimary};
  border-radius: ${scale050};
  flex: 0 0 ${scale100};
  height: ${scale100};
  width: ${scale100};
`;
const PlaceholderText = styled.p `
  display: block;
  width: 100%;
  @media ${mediaXL} {
    display: flex;
    flex: 1 0 1px;
  }
`;
const PlaceholderItemText = styled.span `
  background-color: ${xdlColorSkeletonPrimary};
  border-radius: ${scale010};
  display: inline-block;
  height: ${scale050};
  width: 100%;

  @media ${mediaXL} {
    height: ${scale060};
  }
`;
const StyledLink = styled(Link) `
  ${linkBase}
  ${({ $isActive }) => $isActive &&
    css `
      font-weight: bold;
    `};
  ${({ $membership }) => $membership &&
    css `
      color: ${membershipToXdlColor[$membership]};
    `}
`;
const StyledIconWithBadge = styled(IconWithBadge) `
  ${({ $membership }) => $membership &&
    css `
      color: ${membershipToXdlColor[$membership]};
    `}
`;
const StyledTitle = styled.p `
  line-height: ${scale110};
  margin: 0 0 0 ${spaceL};
  text-decoration: none;
  text-align: center;

  @media ${mediaConfinedNavlessOnly} {
    margin: 0;

    ${({ $size }) => $size === 'long'
    ? css `
            display: none;
          `
    : css `
            display: block;
            white-space: nowrap;
          `};
  }

  @media ${mediaWideNavless} {
    ${({ $size }) => $size === 'long'
    ? css `
            display: block;
          `
    : css `
            display: none;
          `};
  }
`;
export { PlaceholderLi, PlaceholderIcon, PlaceholderText, PlaceholderItemText, StyledIconWithBadge, StyledLink, StyledTitle, };
//# sourceMappingURL=nav-item.styles.js.map